import * as Yup from 'yup';
import { EnvVar } from 'data';
import { envVarsSchema } from 'data/utils/validation';

export type EnvVarsSchema = {
  envVars?: EnvVar[];
};

export const EnvVarsSchemaValidation: Yup.Schema<EnvVarsSchema> = envVarsSchema;
